module Meevo.Plugins.PaymentType {
    angular.module("meevo.plugins.paymentType", []);
}